//
//
//
//
//
//

export default {
  name: 'mt-box-group',
  props: {
    value: {},
    disabled: Boolean,
    max: Number
  },
  watch: {
    value(val) {
      this.$emit('change', val);
    }
  },
  computed:{
    isLimit(){
      if (this.max !== undefined && this.max !== -1) {
        if (this.max > this.value.length) {
          return false;
        } else {
          return true;
        }
      } else {
        return false;
      }
    }
  }
};



// WEBPACK FOOTER //
// ./packages/box-group/src/box-group.vue